import type { SyntheticEvent } from 'react';
import type { TInputType } from '@alfa-bank/site-pure-input/src/models/index';
import type { BaseInputProps } from '@alfalab/core-components-input/components/base-input/Component';

import type { THandler } from '../models/models';

export const getInputType = (type: TInputType | undefined) => {
    let inputType: BaseInputProps['type'];
    switch (type) {
        /** 'phone' нет в коровском инпуте и в целом это не валидный type для <input>
         *   https://www.w3schools.com/html/html_form_input_types.asp
         */
        case 'phone':
            inputType = 'tel';
            break;
        /** type=hidden нет в корах */
        case 'hidden':
            inputType = undefined;
            break;
        default:
            inputType = type || 'text';
    }

    return inputType;
};

export const getHandler =
    <T extends SyntheticEvent<HTMLInputElement>>(callback?: THandler<T>) =>
    (event: T) => {
        if (callback) {
            const { name, value } = event.target as HTMLInputElement;

            callback({ value, name, event });
        }
    };
